export default {
  components: {
    deleteCardModal: {
      cancelButton: 'dt.payments.deposits.components.deleteCardModal.cancelButton',
      container: 'dt.payments.deposits.components.deleteCardModal.container',
      removeButton: 'dt.payments.deposits.components.deleteCardModal.removeButton',
      text: 'dt.payments.deposits.components.deleteCardModal.text',
    },
  },
  wireInstructionsSection: {
    container: 'dt.payments.deposits.wireInstructionsSection.container',
    accountName: 'dt.payments.deposits.wireInstructionsSection.accountName',
    referenceEmail: 'dt.payments.deposits.wireInstructionsSection.referenceEmail',
    doneButton: 'dt.payments.deposits.wireInstructionsSection.doneButton',
  },
  bonusModal: {
    actionButton: 'dt.payments.deposits.bonusModal.actionButton',
  },
  depositView: 'dt.payments.deposits.depositsView',
  depositViewTitle: 'dt.payments.deposits.depositViewTitle',
  depositForm: {
    paymentTypeButton: 'dt.payments.deposits.depositForm.payment.paymentTypeButton',
    depositOption: 'dt.payments.deposits.depositForm.payments.depositOption',
    cardSelect: {
      select: 'dt.payments.deposits.depositForm.cardSelect.select',
      newCard: 'dt.payments.deposits.depositForm.cardSelect.newCard',
      deleteCardIcon: 'dt.payments.deposits.depositForm.cardSelect.deleteCardIcon',
      option: 'dt.payments.deposits.depositForm.cardSelect.option',
    },
    cardDetailsFormSelection: {
      cardholderNameInput:
        'dt.payments.deposits.depositForm.cardDetailsFormSelection.cardholderNameInput',
      cardNumberInput: 'dt.payments.deposits.depositForm.cardDetailsFormSelection.cardNumberInput',
      container: 'dt.payments.deposits.depositForm.cardDetailsFormSelection.container',
      expiryDateInput: 'dt.payments.deposits.depositForm.cardDetailsFormSelection.expiryDateInput',
      cvvInput: 'dt.payments.deposits.depositForm.cardDetailsFormSelection.cvvInput',
    },
    sameBillingAddressCheckbox: 'dt.payments.deposits.depositForm.sameBillingAddressCheckbox',
    billingAddressAutocomplete: 'dt.payments.deposits.billingAddressAutocomplete',
    billingAddressFormSection: 'dt.payments.deposits.depositForm.billingAddressFormSection',
    billingCityInput: 'dt.payments.deposits.depositForm.billingCityInput',
    billingStateSelect: 'dt.payments.deposits.depositForm.billingStateSelect',
    billingZipInput: 'dt.payments.deposits.depositForm.billingZipInput',
    billingCountrySelect: 'dt.payments.deposits.depositForm.billingCountrySelect',
    youWillBeChargedBySplash: 'dt.payments.deposits.depositForm.youWillBeChargedBySplash',
    submitButton: 'dt.payments.deposits.depositForm.submitButton',
    customAmountInput: 'dt.payments.deposits.depositForm.customAmountInput',
    cvvInput: 'dt.payments.deposits.depositForm.cvvInput',
  },
  verification: {
    pinInput: 'dt.payments.deposits.verification.pinInput',
  },
  edgeBoostIntroSection: {
    container: 'dt.payments.deposits.edgeBoostIntroSection.container',
    backButton: 'dt.payments.deposits.edgeBoostIntroSection.backButton',
    continueButton: 'dt.payments.deposits.edgeBoostIntroSection.continueButton',
  },
  depositCompletedModal: {
    successMessage: 'dt.payments.deposits.depositCompletedModal.successMessage',
    newBalance: 'dt.payments.deposits.depositCompletedModal.newBalance',
    continueButton: 'dt.payments.deposits.depositCompletedModal.continueButton',
    footerNote: 'dt.payments.deposits.components.deleteCardModal.footerNote',
  },
  cryptoDirect: {
    container: 'dt.payments.deposits.cryptoDirect.container',
    qrCode: 'dt.payments.deposits.cryptoDirect.qrCode',
    qrLoading: 'dt.payments.deposits.cryptoDirect.qrLoading',
    address: 'dt.payments.deposits.cryptoDirect.address',
    copyButton: 'dt.payments.deposits.cryptoDirect.copyButton',
    retryButton: 'dt.payments.deposits.cryptoDirect.retryButton',
    arrivalsList: 'dt.payments.deposits.cryptoDirect.arrivalsList',
    arrivalItem: 'dt.payments.deposits.cryptoDirect.arrivalItem',
    // EDGE-32113: design-system EmptyState shown when arrivals are ready-but-empty.
    arrivalsEmpty: 'dt.payments.deposits.cryptoDirect.arrivalsEmpty',
    // EDGE-32059: gated crypto deposit flow (B6 retired the old networkPicker test-id above).
    networkList: 'dt.payments.deposits.cryptoDirect.networkList',
    networkRow: 'dt.payments.deposits.cryptoDirect.networkRow',
    assetList: 'dt.payments.deposits.cryptoDirect.assetList',
    assetRow: 'dt.payments.deposits.cryptoDirect.assetRow',
    addressSheet: 'dt.payments.deposits.cryptoDirect.addressSheet',
    confirmReveal: 'dt.payments.deposits.cryptoDirect.confirmReveal',
    networkUnavailableBack: 'dt.payments.deposits.cryptoDirect.networkUnavailableBack',
    // In-sheet back-to-assets control (the sheet steps have no gutter; the network/asset list steps use
    // the gutter BackButton). UAT finding #3: the whale loader shown during loading/settingUp.
    sheetBack: 'dt.payments.deposits.cryptoDirect.sheetBack',
    sheetLoader: 'dt.payments.deposits.cryptoDirect.sheetLoader',
    // EDGE-32497: the 30-day "address was updated" notice in the sheet's success phase.
    addressChangedNotice: 'dt.payments.deposits.cryptoDirect.addressChangedNotice',
  },
};
